import { Input } from '@formily/antd-mobile';
import { createSchemaComponent } from '../../shared';
export default createSchemaComponent({
    componentName: 'Input',
    component: Input,
});
